import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// FETCH CATEGORY LIST
export const fetchPettyCashCategoryList = createAsyncThunk("fetchPettyCashCategoryList", async (_, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`/category/list?categoryType=Petty Cash&page=1&limit=100`);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const PettyCashCategoryListSlice = createSlice({
	name: "PettyCashCategoryListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCategoryListState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashCategoryList.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(fetchPettyCashCategoryList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPettyCashCategoryList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCategoryListState } = PettyCashCategoryListSlice.actions;
export default PettyCashCategoryListSlice.reducer;
